<div class="FormsVisitCardService">
    @if (isLoading || isSaving) {
        <app-pg-loading [isOverlay]="isSaving"></app-pg-loading>
    }
    @if (!isLoading) {
        @if (viewOnly) {
            <div>
                <app-pg-detail [formLayout]="formLayout" [hideEmpty]="true" [currentLanguage]="true"></app-pg-detail>
            </div>
        }
        @else {
            <div>
                <app-pg-form #formComponent [formLayout]="formLayout" [languages]="availableLanguages" [hasSubmit]="false" [hideAdvanced]="true" (advancedModeChange)="onAdvancedModeChange($event)" (valueChange)="onValueChange($event)"></app-pg-form>
            </div>
        }
    }
</div>